import { render, staticRenderFns } from "./ExcBaseTextDropdown.vue?vue&type=template&id=05521596&scoped=true&"
import script from "./ExcBaseTextDropdown.vue?vue&type=script&lang=js&"
export * from "./ExcBaseTextDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ExcBaseTextDropdown.vue?vue&type=style&index=0&id=05521596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05521596",
  null
  
)

export default component.exports